// src/components/admin/nornsweave/FixedClassesTab.js
import React from 'react';
import { useAdminNornsWeave } from './AdminNornsWeaveContext';
import { formatTime12 } from '../../TimePicker';

function FixedClassesTab({
  onAddFixedClass,
  onEditFixedClass,
  onDeleteFixedClass,
  onResendFixedClassEmail
}) {
  const { fixedClasses } = useAdminNornsWeave();

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-slate-800">Fixed Classes</h2>
          <p className="text-slate-600 text-sm mt-1">Recurring weekly classes with assigned teachers</p>
        </div>
        <button
          onClick={onAddFixedClass}
          className="bg-cyan-600 text-white px-4 py-2 rounded-lg hover:bg-cyan-700 transition-colors"
        >
          + Add Fixed Class
        </button>
      </div>

      {fixedClasses.length === 0 ? (
        <div className="text-center py-12 bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl border-2 border-cyan-200">
          <div className="text-6xl mb-4">📌</div>
          <p className="text-slate-600 text-lg font-medium">No fixed classes yet</p>
          <p className="text-slate-500 text-sm mt-2">Add recurring weekly classes that automatically appear on the calendar</p>
        </div>
      ) : (
        <div className="space-y-4">
          {fixedClasses.map(cls => (
            <div key={cls.id} className="border-2 border-cyan-200 rounded-lg p-4 bg-cyan-50">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                      cls.library === 'elementary' ? 'bg-purple-200 text-purple-800' : 'bg-indigo-200 text-indigo-800'
                    }`}>
                      {cls.library === 'elementary' ? 'Elementary' : 'Middle School'}
                    </span>
                    <span className="px-3 py-1 rounded-full text-sm font-medium bg-cyan-200 text-cyan-800">
                      Every {cls.dayOfWeek}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
                    <div><span className="text-slate-500">Grade:</span><span className="ml-2 font-medium">{cls.grade}</span></div>
                    <div><span className="text-slate-500">Time:</span><span className="ml-2 font-medium">{formatTime12(cls.startTime)} - {formatTime12(cls.endTime)}</span></div>
                    <div><span className="text-slate-500">Teacher:</span><span className="ml-2 font-medium">{cls.teacherName}</span></div>
                    <div><span className="text-slate-500">Email:</span><span className="ml-2 font-medium">{cls.teacherEmail}</span></div>
                    {cls.studentCount && <div><span className="text-slate-500">Students:</span><span className="ml-2 font-medium">{cls.studentCount}</span></div>}
                  </div>
                  {cls.exceptions?.length > 0 && (
                    <div className="mt-2 text-sm text-orange-600">
                      Exceptions: {cls.exceptions.map(ex => ex.date).join(', ')}
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  <button
                    onClick={() => onResendFixedClassEmail(cls)}
                    className="bg-blue-500 text-white px-3 py-1.5 rounded-lg hover:bg-blue-600 transition-colors text-sm"
                  >
                    Resend Email
                  </button>
                  <button
                    onClick={() => onEditFixedClass(cls)}
                    className="bg-amber-500 text-white px-3 py-1.5 rounded-lg hover:bg-amber-600 transition-colors text-sm"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => onDeleteFixedClass(cls.id)}
                    className="bg-red-500 text-white px-3 py-1.5 rounded-lg hover:bg-red-600 transition-colors text-sm"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FixedClassesTab;
